import EventEmitter from 'eventemitter3';
import { AbstractWsConnector, wsDefaultConnector, WsMessageIdentitySyncType } from '@/ws';
import { WsIdentitySyncFailedMessageContent } from './types';

const IDENTITY_SYNC_FAILED_EVENT = 'identitySyncFailed';

export class IdentitySyncNotifier {
  protected readonly eventEmitter = new EventEmitter();

  constructor(protected readonly wsConnector: AbstractWsConnector) {
    this.wsConnector.on((type, content) => {
      if (type !== WsMessageIdentitySyncType.IDENTITY_SYNC_FAILED) return;
      this.eventEmitter.emit(IDENTITY_SYNC_FAILED_EVENT, content as WsIdentitySyncFailedMessageContent);
    });
  }

  on(handler: (message: WsIdentitySyncFailedMessageContent) => void) {
    this.eventEmitter.on(IDENTITY_SYNC_FAILED_EVENT, handler);
    return () => {
      this.eventEmitter.off(IDENTITY_SYNC_FAILED_EVENT, handler);
    };
  }
}

export const identitySyncNotifier = new IdentitySyncNotifier(wsDefaultConnector);
